import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  TableHead,
  TableSortLabel
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import Reports from './Reports';
import { Switch } from '../common/Switch';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import './report.less';
import DateFnsUtils from '@date-io/date-fns';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _, { cloneDeep } from 'lodash';
import PageHeader from '../common/PageHeader';
import ReportButtons from './ReportButtons';
import {
  GenerateAbsoluteURL,
  removeDuplicates,
  orderBy,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import { getFormattedHeaders, getFormattedValues } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TableWithPaginations from './TableWithPaginations';
import PropTypes from 'prop-types';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage';

// Unmapped Reports Component
export default class UnmappedReport extends Component {
  // Constructor to define initial state
  constructor(props) {
    super(props);
    this.state = {
      sectionId: this.props.sectionId,
      reportName: this.props.sectionName,
      reportURL: this.props.reportURL,
      showMain: false,
      reportData: [],
      originalReportData: [],
      showReport: false,
      order: 'desc',
      orderByColumn: '',
      rows: [],
      filterList: [],
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false,
      showAllRecords: false
    };

    this.baseState = this.state;
  }

  // Method to get data from backend before components are mountd
  componentDidMount() {
    window.scrollTo(0, 0);
    this.GetRptUnmappedReports(true);
  }

  // Go back to Report listing page
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Date change event of calendar
  handleDateChange = (date, name) => {
    this.setState({
      [name]: moment(date).format(DateFormat)
    });
  };

  // Get list of filters to show filters on UI
  getUpdatedFilterList = (filterList) => {
    filterList = filterList?.map(x => {
      if (x.FilterName === 'Employee Name' && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Employee.GetEmployeeMasterData + '?showInActive=true&isDeptUnmapped=true';
        x.Key = 'EmployeeMasterData';
      }
      if (x.FilterName === 'Supervisor' && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Employee.GetEmployeeSupervisorList;
        x.Key = 'EmployeeSupervisorList';
      }
      if (x.FilterName === 'Department' && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Employee.GetDepartmentMasterData;
        x.Key = 'DepartmentMasterData';
      }
      if (x.FilterName === 'Division' && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Allocation.GetDivisions;
        x.Key = 'DivisionMasterData';
      }
      if (x.FilterName === 'Property' && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Property.GetPropertyMasterData;
        x.Key = 'PropertyMasterData';
      }
      if (x.FilterName === 'Property Type' && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Property.GetPropertyTypeMasterData;
        x.Key = 'PropertyTypeMasterData';
      }
      if ((x.FilterName === 'Market' || x.FilterName === 'Base Market') && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Market.GetMarketMasterdata;
        x.Key = 'MarketMasterdata';
      }
      if (x.FilterName === 'Pma Title' && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Users.GetPmaTitles;
        x.Key = 'PmaTitlesData';
      }
      if (x.FilterName === 'Title' && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Employee.GetDesignationMasterData;
        x.Key = 'DesignationMasterData';
      }
      if (x.FilterName === 'Client' && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Transition.GetClientListingData;
        x.Key = 'ClientMasterData';
      }
      if (x.FilterName === 'Legal Entity' && x.ShowLastValueInList === true) {
        x.ApiName = API_URL.Transition.GetCustomerListingData;
        x.Key = 'CustomerMasterData';
      }
      return x;
    });
    return filterList;
  }

  // Get master data to fill filters options
  GetMasterData = (filterList) => {
    const apiList = [];
    filterList.filter(x => x.ShowLastValueInList === true).forEach((x, index) => {
      apiList.push({
        url: x.ApiName,
        key: x.Key
      });
    });
    this._asyncRequest = apiBatchRequest(
      apiList.filter(x => x.url !== undefined)
    )
      .then(
        (response) => {
          this._asyncRequest = null;

          filterList.filter(x => x.ShowLastValueInList === true).forEach((filter, i) => {
            if (response[filter.Key]?.data?.find(x => x[filter.FilterKeyName] === 'All') === undefined) {
              response[filter.Key]?.data?.unshift({ [filter.FilterKeyName]: 'All' });
            }
            if (filter.FilterKeyName === 'customerName') {
              const uniqueAssignmentData = (removeDuplicates(response[filter.Key]?.data?.map(x => {
                return { customerId: x.customerId, customerName: x.customerName };
              }), 'customerName') || []).filter(x => x.customerName !== null) || [];
              response[filter.Key].data = uniqueAssignmentData;
            }
            this.setState(state => ({ ...state, [filter.Key]: response[filter.Key]?.data, filterList: filterList, [filter.FilterKeyName]: [{ [filter.FilterKeyName]: 'All' }] }));
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Get filters dynamically based on Report selection
  getDynamicFilter = (filterList) => {
    const reportParam = [];

    filterList?.map(filterData => {
      if (filterData.ShowLastValueInList === true) {
        const filterId = this.state[filterData.FilterKeyName]?.map(x => x[filterData.ReportParameter]);
        if (reportParam.length === 0) {
          reportParam.push({
            [filterData.ReportParameter]: (filterId === undefined || filterId.join('|') === undefined || filterId.join('|') === '') ? '0' : filterId.join('|')
          });
        } else {
          reportParam[0][filterData.ReportParameter] = (filterId === undefined || filterId.join('|') === undefined || filterId.join('|') === '') ? '0' : filterId.join('|');
        }
      } else if (filterData.ShowLastValueInList === false && filterData.DatePickerOptional !== true && filterData.FilterDataType === 'Boolean') {
        if (reportParam.length === 0) {
          reportParam.push({
            [filterData.ReportParameter]: this.state.showAllRecords
          });
        } else {
          reportParam[0][filterData.ReportParameter] = this.state.showAllRecords
        }
      } else if (filterData.ShowLastValueInList === false && filterData.DatePickerOptional === true && this.state[filterData.FilterKeyName] !== undefined && this.state[filterData.FilterKeyName] !== null && this.state[filterData.FilterKeyName] !== '') {
        if (reportParam.length === 0) {
          reportParam.push({
            [filterData.ReportParameter]: moment(this.state[filterData.FilterKeyName]).format(DateFormat)
          });
        } else {
          reportParam[0][filterData.ReportParameter] = moment(this.state[filterData.FilterKeyName]).format(DateFormat);
        }
      } else if (filterData.ShowLastValueInList === false && filterData.DatePickerOptional === true) {
        if (reportParam.length === 0) {
          reportParam.push({
            [filterData.ReportParameter]: moment().format(DateFormat)
          });
        } else {
          reportParam[0][filterData.ReportParameter] = moment().format(DateFormat);
        }
      }
      return filterData;
    });
    return reportParam;
  }

  // Get report data
  GetRptUnmappedReports = (callMaster = false) => {
    const { sectionId, filterList } = this.state;
    const reportParam = this.getDynamicFilter(filterList);

    const params = {
      sectionId: sectionId,
      reportParam: reportParam.length > 0 ? JSON.stringify(reportParam) : null
    };

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Json.GetRptUnmappedReports,
        params,
        key: 'reportData'
      }
    ])
      .then(({ reportData }) => {
        this._asyncRequest = null;
        if (reportData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }

        this.setState({
          originalReportData: (reportData.data || []),
          reportData: cloneDeep((reportData.data || [])),
          configuration: reportData.history,
          filterList: this.getUpdatedFilterList(reportData.rawData),
          showReport: true,
          rows: this.renderTableRow(orderBy(cloneDeep((reportData.data || [])), this.state.orderByColumn, this.state.order), reportData.history)
        }, () => {
          if (callMaster === true) {
            this.GetMasterData(this.state.filterList);
          }
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Handle sorting on table columns
  handleRequestSort = (property, type) => {
    const isAsc = this.state.orderByColumn === property && this.state.order === 'asc';

    let rows = [];
    rows = [...rows, ...this.renderTableRow(
      orderBy((this.state.reportData || []), property, isAsc ? 'desc' : 'asc'),
      this.state.configuration
    )];
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderByColumn: property,
      rows
    });
  }

  // Render report data into the table component
  renderTable = (rows) => {
    const { order, orderByColumn, configuration } = this.state;
    return (
      <Table className="reportTable" id="rptTable">
        <TableHead className='background-table-header'>
          <TableRow>
            {configuration?.filter(x => x.IsVisible === 1).map((config) => (
              <TableCell
                key={config.DbColumn}
                sortDirection={orderByColumn === config.DbColumn ? order : false}
              >
                {
                  <TableSortLabel
                    active={orderByColumn === config.DbColumn}
                    direction={orderByColumn === config.DbColumn ? order : 'asc'}
                    onClick={() => { this.handleRequestSort(config.DbColumn, config.DataFormat); }}
                  >
                    {config.DataFormat !== undefined ? getFormattedHeaders(config.UiColumn, (config.DataFormat === 'Boolean' ? 'Text' : config.DataFormat)) : config.UiColumn
                    }
                  </TableSortLabel>
                }
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

  // Reset filters and reload the table with default filter values
  resetPage = async () => {
    const { filterList } = this.state;
    // await filterList.filter(x => x.ShowLastValueInList === true).forEach((filter, i) => {
    await filterList.forEach((filter, i) => {
      if (filter.ShowLastValueInList === true) {
        this.setState(state => ({ ...state, [filter.FilterKeyName]: [{ [filter.FilterKeyName]: 'All' }], showReport: false, showDetails: true }));
      }
      if (filter.ShowLastValueInList === false && filter.DatePickerOptional === true) {
        this.setState(state => ({ ...state, [filter.FilterKeyName]: moment().format(DateFormat), showReport: false, showDetails: true }));
      }
      if (filter.ShowLastValueInList === false && filter.FilterDataType === 'Boolean' && filter.DatePickerOptional !== true) {
        this.setState(state => ({ ...state, showAllRecords: false, showReport: false, showDetails: true }));
      }
    });
    await this.GetRptUnmappedReports();
  };

  // Open report in another page to print
  handlePrintClick = () => {
    this.setState(
      {
        printPage: true
      },
      window.print()
    );
  };

  // Event occurs when filter value is changed
  handleChange = (_e, value, name, optionLabel) => {
    if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
        this.setState({ [name]: value });
      } else if ((value || []).find(x => x[optionLabel] === 'All')) {
        this.setState({ [name]: [{ [optionLabel]: 'All' }] });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      value = (value || []).filter(x => x[optionLabel] !== 'All');
      if (value && value.length === 0) {
        value = [{ [optionLabel]: 'All' }];
      }
      this.setState({ [name]: value });
    }
  };

  // Render rows in the table
  renderTableRow = (data, columns) => {
    return this.renderTableCell(
      data,
      columns,
      []
    );
  };

  // Render cell in the table row
  renderTableCell = (groupedData, columns, tableCell = [], rowCount = 0) => {
    groupedData.forEach((d, i) => {
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const key = i + '_' + d.EmployeeId + rowCount + '_' + i;
      tableCell.push(
        <TableRow key={key} className={'rpt-topBorder'}>
          {
            columns.map((col, index) => {
              return (
                <>
                  {
                    col.IsVisible === 1
                      ? <TableCell key={d[col.DbColumn] + index} className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} >
                        <>
                          {getFormattedValues(d[col.DbColumn], col.DataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}
                        </>
                      </TableCell>
                      : ''
                  }

                </>
              );
            })
          }

        </TableRow>
      );
      rowCount++;
    });
    if (groupedData?.length <= 0) {
      tableCell.push(<TableRow> <TableCell colSpan={8} align='center'>No records found</TableCell> </TableRow>);
    }
    return tableCell;
  }

  // Download report into excel or pdf format
  downloadFile = (fileMimeType, type, isPrint = false) => {
    const { filterList, reportURL, reportName, sectionId } = this.state;

    const dataValue = [];
    const reportParam = this.getDynamicFilter(filterList);

    dataValue.push(
      {
        key: 'SectionId',
        value: sectionId
      },
      {
        key: 'ReportParam',
        value: reportParam.length > 0 ? JSON.stringify(reportParam) : null
      }
    );

    const url = GenerateAbsoluteURL(dataValue, [], reportURL, type, false, true);

    downloadReport(
      url,
      reportName,
      fileMimeType,
      type,
      isPrint
    );
  }

  // Change event of switch button to show or skip Mapping Not Required records
  showAllRecords = (checked) => {
    this.setState({ showAllRecords: checked });
  }

  // Render components based on the conditions
  render() {
    const {
      showMain,
      reportData,
      showReport,
      rows,
      reportName,
      filterList,
      showAllRecords
    } = this.state;

    return (
      <div>
        {showMain
          ? (
            <Reports></Reports>
          )
          : (
            <>
              <PageHeader
                key={'Unmapped_Report'}
                title={reportName}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                {reportName}
              </PageHeader>
              <Grid
                container
                spacing={3}
                className="no-print row bottom-xs"
                style={{ marginLeft: '10px' }}
              >
                {filterList?.length > 0 && filterList?.map(filter => {
                  return (
                    <>
                      {filter.ShowLastValueInList === true &&
                        <Grid item xs={12} lg={2}>
                          <Autocomplete
                            multiple
                            blurOnSelect
                            value={this.state[filter.FilterKeyName] || []}
                            onChange={(e, val) => this.handleChange(e, val, filter.FilterKeyName, filter.FilterKeyName)}
                            id="tags-standard"
                            options={removeDuplicates(this.state[filter.Key] || [], filter.FilterKeyName)}
                            limitTags={1}
                            getOptionLabel={(option) => option[filter.FilterKeyName]}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label={filter.FilterName}
                              />
                            )}
                          />
                        </Grid>}
                      {filter.ShowLastValueInList === false && filter.DatePickerOptional === true &&
                        <Grid item xs={12} lg={2}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid container>
                              <KeyboardDatePicker
                                margin="normal"
                                format="MM/dd/yyyy"
                                id="date-picker-dialog"
                                label={filter.FilterName}
                                name={filter.FilterKeyName}
                                value={this.state[filter.FilterKeyName] || moment().format(DateFormat)}
                                onChange={(e) => this.handleDateChange(e, filter.FilterKeyName)}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                                className="w-100"
                                inputProps={{ readOnly: true }}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                        </Grid>
                      }
                      {filter.ShowLastValueInList === false && filter.FilterDataType === 'Boolean' && filter.DatePickerOptional !== true &&
                        <Grid item xs={12} lg={2}>
                          <Switch
                            isChecked={showAllRecords}
                            onChangeValues={(checked, key) => {
                              this.showAllRecords(checked);
                            }}
                            id={'switch_'+ (filter?.FilterKeyName || 'isMappingRequired')}
                            labelText={filter?.FilterName}
                            fullWidth
                          />
                        </Grid>
                      }
                    </>
                  );
                })}

                {filterList?.length > 0 &&
                 <div className="col-xs-12 col-lg-12 filter-action-group">
                  <div className="row start-xs end-xs">
                      <ReportButtons
                      resetPage={this.resetPage}
                      handleSubmit={this.GetRptUnmappedReports}
                      handlePrintClick={this.handlePrintClick}
                      downloadFile={this.downloadFile}
                      data={reportData}
                      hideAdvanceLink={true}
                    />
                  </div>
                </div>}
              </Grid>
              {showReport && (reportData == null || reportData.length === 0) && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
              {showReport && reportData !== null && reportData.length > 0 && (
                <div className="container" style={{ marginTop: '1rem' }}>
                  <TableWithPaginations
                    tableData={rows}
                    renderTable={this.renderTable}
                    order={this.state.order}
                    oBy={this.state.orderByColumn}
                  />
                </div>
              )}
            </>
          )
        }
      </div>
    );
  }
}

// Define Prop types
UnmappedReport.propTypes = {
  sectionId: PropTypes.number,
  sectionName: PropTypes.string,
  reportURL: PropTypes.string
};
